export const displayCaseNo = (patient) => {
    return (
        `${patient?.LDMCaseNo ? patient?.LDMCaseNo : `RBK${patient?.caseNumber}` || ''}`
    )
}